var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            staticStyle: { width: "100%" },
            attrs: { data: _vm.goodsAllocItemList, border: "" }
          },
          [
            _c("el-table-column", {
              attrs: { prop: "title", label: "商品名称", width: "150" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "catName", label: "分类名称", width: "150" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "brandName", label: "品牌名称", width: "120" }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "quantity",
                label: "配货数量",
                width: "100"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(rows.row.quantity * rows.row.ioFlag))
                      ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "createTime",
                label: "配货时间",
                width: "180"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "desireArriveDate",
                label: "要求到货时间",
                width: "130"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "desc", label: "商品说明" }
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "block pagination-layout" },
      [
        _vm.totalCount > 0
          ? _c("el-pagination", {
              staticClass: "mt10",
              attrs: {
                background: "",
                layout: "total, sizes, prev, pager, next, jumper",
                "page-size": _vm.pageSize,
                "page-sizes": _vm.pageSizes,
                "current-page": _vm.pageNumber,
                total: _vm.totalCount
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d34cf3b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d34cf3b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/OrderGoodsAllocDetails.vue
// module id = 1820
// module chunks = 1